import { TextCloud } from '@/shared/ui';
import { useLocation } from '@tanstack/react-router';

export const ReportHeaderLeft = ({ toolTipIcon }: { toolTipIcon?: boolean }) => {
    const { pathname } = useLocation();
    const isReportStnts = pathname === '/report/stnts';
    const liText = isReportStnts ? '전체 학생 비교' : '항목';

    return (
        <div className="box-left">
            <ul>
                <li style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
                    {liText}
                    {toolTipIcon && (
                        <TextCloud
                            btnStr="정답률 표시 안내"
                            btnClass="btn-type2"
                            boxClass="case2-type1"
                        >
                            <p className="mark mark2">
                                URL 응시 발행한 경우, 학생 목록은 <strong>[ 입장하기 ]</strong>{' '}
                                버튼을 클릭한 순서로 노출됩니다.
                            </p>
                        </TextCloud>
                    )}
                </li>
                <li>
                    <div className="score-tit">점수(평가기준)</div>
                    <div className="guide-tooltip">
                        <span>채점가이드</span>
                        <TextCloud
                            btnStr="정답률 표시 안내"
                            btnClass="btn-type2"
                            boxClass="case2-type1"
                        >
                            {/* <div className="guide-info-box">
                                <div className="tip_con">정답률 표시</div>
                                <div className="tip_con2">
                                    <p className="mark mark1">
                                        <strong>미달</strong> (0~30% 미만)
                                    </p>
                                    <p className="mark mark2">
                                        <strong>보통</strong> (30~70% 미만)
                                    </p>
                                    <p className="mark mark3">
                                        <strong>우수</strong> (70~100%)
                                    </p>
                                </div>
                            </div> */}
                            <div className="guide-info-box">
                                <div className="tip_con">정오 표시</div>
                                <div className="tip_con2">
                                    <p>
                                        <i className="ico-point good"></i> 정답(최고점)
                                    </p>
                                    <p>
                                        <i className="ico-point average"></i> 부분(1~최고점 미만)
                                    </p>
                                    <p>
                                        <i className="ico-point bad"></i> 오답(0점)
                                    </p>
                                </div>
                            </div>
                        </TextCloud>
                    </div>
                </li>
            </ul>
        </div>
    );
};
